import {Injectable} from '@angular/core';

@Injectable()
export class BackgroundColorService {
    back: string;
    readonly LOGINBACK = ['/login', '/logout'];
    readonly WHITESMOKEBACK = ['/specialoffer', '/fee/', '/moderate', '/markup', '/rate', '/priceAndAvailability',
        '/reviews', '/opaquerate', 'audit-a2', '/pickupPointFee', '/contact', '/internal-error',
        '/home', '/restrictions', '/booking', '/additionals', '/insurances', '/pointsOfSale','/additionalPoint','agerange'];

    setBackgroundState(url: string) {

        if (this.WHITESMOKEBACK.some((value) => url.indexOf(value) != -1)) {
            this.back = 'WHITESMOKE-BACK';
        } else {
            this.back = 'WHITE-BACK';
        }

        if (this.LOGINBACK.some((value) => url.indexOf(value) != -1)) {
            this.back = 'LOGIN-BACK';
        }
    }

    getBack(): string {
        return this.back;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/root/background-color/background-color.service.ts